import React from 'react';
import { Modal } from 'antd';

export function MultiStepModal({
  open,
  onCancel,
  currentStep,
  steps,
  width = 800,
  closeIcon,
  testId,
}) {
  const activeStep = steps?.[currentStep];
  if (!activeStep) {
    return null;
  }

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      title={activeStep.title}
      footer={activeStep.footer}
      bodyStyle={activeStep.bodyStyle}
      width={activeStep.width || width}
      closeIcon={closeIcon}
      data-testid={testId}
    >
      {activeStep.content}
    </Modal>
  );
}
